import { Enrolment } from '@/models/enrolment';

import { Event } from './event';

export class EnrolmentEditRequestedEvent extends Event<Enrolment> {}
